// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"Clock_buttonsContainer__JvUIc","clock":"Clock_clock__ZbZ4j","watch":"Clock_watch__rgdGL","more":"Clock_more__io0Ts","spanDate":"Clock_spanDate__+I6gU"};